@let topbar = headerService.topbarConfig();
@if (topbar && headerService.showTopbar()) {
  @let topbarBgColor = styleService.getColorClass(topbar.backgroundColor, 'bg');
  @let topbarTextColor = styleService.getColorClass(topbar.textColor, 'text');
  @let topBarFont = styleService.getFontClasses(topbar.font);
  <div
    [ngClass]="[topbarBgColor, topbar.divider ? 'border-primary-main border-b border-solid' : '']"
    [style.border-bottom-width]="topbar.divider ? '0.5px' : null"
    class="relative top-0 flex h-auto min-h-12 w-full items-center justify-center overflow-hidden pt-2 pr-5 pb-2 pl-5 text-center break-words duration-200 lg:pt-4 lg:pr-28 lg:pb-4 lg:pl-28"
  >
    <div class="p" [style.font-size.px]="topbar.textSize">
      @switch (topbar.template) {
        @case ('openingHours') {
          <span class="text-center" [ngClass]="[topBarFont, topbarTextColor]">
            {{ headerService.todaysOpeningTime() ?? ('header.topbar.openingHours' | translate) }}
          </span>
        }
        @case ('phoneNumber') {
          <a
            class="text-center transition-colors"
            [href]="'tel:' + headerService.company()?.contact?.phone"
            [ngClass]="[topBarFont, topbarTextColor]"
          >
            {{ 'header.topbar.phone' | translate }}: {{ headerService.company()?.contact?.phone }}
          </a>
        }
        @case ('custom') {
          @let topbarData = headerService.topbar();
          @if (topbarData) {
            <div class="flex items-center justify-center gap-4" [ngClass]="[topBarFont, topbarTextColor]">
              @for (item of topbarData.customItems; track $index) {
                @if (item.url) {
                  @let isExternal = item.url?.startsWith('http');
                  <a
                    [href]="system.getLink(item.url)"
                    [target]="isExternal ? '_blank' : '_self'"
                    [attr.rel]="isExternal ? 'noopener noreferrer' : null"
                    class="hover:underline"
                  >
                    {{ item.content }}
                  </a>
                } @else {
                  <span>
                    {{ item.content }}
                  </span>
                }
              }
            </div>
          }
        }
      }
    </div>
    <button
      class="absolute top-1/2 right-5 flex size-5 -translate-y-1/2 items-center justify-center"
      [ngClass]="[topbarTextColor]"
      (click)="handleClose()"
      [attr.aria-label]="'header.aria.closeTopbar' | translate"
    >
      <gs-icon iconName="x" iconWeight="light"></gs-icon>
    </button>
  </div>
}
